'use client';

import React, { FC } from 'react';
import { Box, Img, TextBox } from './styles';
import { Container, Wrapper } from '@/features/pages/home';

import tableSetup from '@/assets/svg/table-setup.svg';
import { Button, Typography } from '@mui/material';
import { COLORS, PATHS } from '@/constants';
import { ArrowRight } from '@/components';
import { useTranslations } from 'next-intl';
import Link from 'next/link';

type SellPropertyProps = {
  bg?: string;
};

export const SellProperty: FC<SellPropertyProps> = ({ bg }) => {
  const t = useTranslations();

  return (
    <Wrapper>
      <Container>
        <Box $bg={bg}>
          <Img>
            <img src={tableSetup.src} alt="table-setup" />
          </Img>

          <TextBox>
            <Typography
              lineHeight={1}
              fontSize={{ xs: 24, sm: 29, md: 30 }}
              fontWeight={700}
              color={COLORS['blue']}
            >
              {t('sellProperty.title')}
            </Typography>
            <Typography
              lineHeight={1.32}
              fontSize={{ sm: 17, md: 18 }}
              fontWeight={600}
              color={COLORS.gray}
            >
              {t('sellProperty.desc')}
            </Typography>
          </TextBox>

          <Button
            variant="primary"
            endIcon={<ArrowRight />}
            component={Link}
            href={`/${PATHS.BROKERS}`}
          >
            <Typography fontSize={16} fontWeight={600} textTransform={'none'}>
              {t('sellProperty.submit')}
            </Typography>
          </Button>
        </Box>
      </Container>
    </Wrapper>
  );
};
